module.exports = __webpack_public_path__ + "static/media/linkedin.b2ea6ef4.svg";